/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCopyControl.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/copy-control";

export class AutogenModelCopyControl<RowType extends ModelRow> extends Endpoint<RowType, RowCopyControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCopyControl extends ModelRow<RowCopyControlFields> {
	constructor(values?: Partial<RowCopyControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCopyControlFields {
	activity_count: number;
	activity_start_date: Date;
	add_empty_distance_occ: string;
	add_finance_charge: string;
	address1: string;
	address2: string;
	allocation: string;
	allow_inc_in_frt: string;
	allow_web_tendering: string;
	auto_rate: string;
	auto_tax: string;
	available_template: number;
	average_bill: number;
	average_bill_c: string;
	average_bill_d: Date;
	average_bill_n: number;
	average_bill_r: number;
	average_pay_days: number;
	balance: number;
	balance_c: string;
	balance_d: Date;
	balance_n: number;
	balance_r: number;
	benchmark_ctg_uid: number;
	benchmark_tar_uid: number;
	bill_distance: string;
	bill_due_days: number;
	bill_format_flag: string;
	bill_of_lading: string;
	bill_template: number;
	bill_transfer_when: string;
	billed_loads: number;
	bl_logo: string;
	bl_logo_name: string;
	blanket_buy_tariff_id: string;
	blanket_sell_tariff_id: string;
	booking_no: string;
	bridge_id: string;
	brk_qual_profile: string;
	brokerage_filter: string;
	brokerage_workflow: string;
	business_hours: string;
	business_number: string;
	buy_tariff_id: string;
	carrier_cost: string;
	carrier_scorecard_exported: string;
	category: string;
	cert_of_ins_date: Date;
	charge_detention: string;
	chassis_chargeby: string;
	chassis_freedays: number;
	chassis_rate: number;
	chassis_rate_c: string;
	chassis_rate_d: Date;
	chassis_rate_n: number;
	chassis_rate_r: number;
	city: string;
	city_id: number;
	coll_thresh_pd1: number;
	coll_thresh_pd1_c: string;
	coll_thresh_pd1_d: Date;
	coll_thresh_pd1_n: number;
	coll_thresh_pd1_r: number;
	coll_thresh_pd2: number;
	coll_thresh_pd2_c: string;
	coll_thresh_pd2_d: Date;
	coll_thresh_pd2_n: number;
	coll_thresh_pd2_r: number;
	coll_thresh_pd3: number;
	coll_thresh_pd3_c: string;
	coll_thresh_pd3_d: Date;
	coll_thresh_pd3_n: number;
	coll_thresh_pd3_r: number;
	coll_thresh_pd4: number;
	coll_thresh_pd4_c: string;
	coll_thresh_pd4_d: Date;
	coll_thresh_pd4_n: number;
	coll_thresh_pd4_r: number;
	collections_id: string;
	collections_ok: string;
	comments: string;
	"company.ace_id": string;
	"company.address1": string;
	"company.address2": string;
	"company.city": string;
	"company.company_id": string;
	"company.company_type": string;
	"company.currency": string;
	"company.def_move_type": string;
	"company.distance_um": string;
	"company.dot_number": string;
	"company.email_address": string;
	"company.email_bcc": string;
	"company.email_client": string;
	"company.email_host": string;
	"company.email_imap_host": string;
	"company.email_imap_password": string;
	"company.email_imap_sent_folder": string;
	"company.email_imap_ssl": string;
	"company.email_imap_username": string;
	"company.email_password": string;
	"company.email_port": number;
	"company.email_protocol": string;
	"company.email_use_sent_folder": string;
	"company.email_username": string;
	"company.enable_br_ltl": string;
	"company.enable_dd_encryption": string;
	"company.enable_encryption": string;
	"company.enable_mfa": string;
	"company.enable_phoneformat": string;
	"company.enable_portal_mfa": string;
	"company.enable_transferlog": string;
	"company.enable_web_mfa": string;
	"company.fax": string;
	"company.icon_image": string;
	"company.id": string;
	"company.is_main_company": string;
	"company.logo": string;
	"company.logo_name": string;
	"company.ltl_company": string;
	"company.mfa_prompt_interval": number;
	"company.multi_curr_enabled": string;
	"company.name": string;
	"company.phone_format": string;
	"company.phone_number": string;
	"company.scac": string;
	"company.security_admin_email": string;
	"company.state": string;
	"company.support_email": string;
	"company.temperature_um": string;
	"company.user_lic_contact_email": string;
	"company.user_lic_contact_name": string;
	"company.user_lic_contact_phone": string;
	"company.website": string;
	"company.weight_um": string;
	"company.zip": string;
	company_id: string;
	company_ids: string;
	confidence_level: number;
	consignee_ref: string;
	container_chargeby: string;
	container_dates: string;
	container_dray_pay: string;
	container_freedays: number;
	container_ldport: string;
	container_number: string;
	container_order: string;
	container_pod: string;
	container_rate: number;
	container_rate_c: string;
	container_rate_d: Date;
	container_rate_n: number;
	container_rate_r: number;
	container_type: string;
	container_vessel: string;
	contract_cbc: string;
	contract_ccc: string;
	contract_gbc: string;
	contract_gcc: string;
	contract_sbc: string;
	contract_scc: string;
	controlling_carrier_code: string;
	conversion_date: Date;
	copy_bill_to: string;
	copy_car_to_frght: string;
	copy_ctrl_party: string;
	copy_ovrd_payee: string;
	copy_revenue_id: string;
	copy_status: string;
	copy_to_company: string;
	copy_type: string;
	cost_ctg_uid: number;
	cost_tar_uid: number;
	covered_template: number;
	cp_logo: string;
	cp_logo_name: string;
	credit_application: string;
	credit_check_date: Date;
	credit_limit: number;
	credit_limit_c: string;
	credit_limit_d: Date;
	credit_limit_n: number;
	credit_limit_r: number;
	credit_status: string;
	credit_warning_pct: number;
	ctg_uid: number;
	currency_type: string;
	cust_order_no: string;
	cust_requestor_load_id: string;
	cust_stmt_template: number;
	d_and_b_code: string;
	d_and_b_date: Date;
	d_and_b_number: string;
	dates: string;
	days_between_calls: number;
	deadhead_target: number;
	ded_last_fixed_cost_billdt: Date;
	dedicated_cycle: string;
	dedicated_revenue_code_id: string;
	dedicated_seg_alloc_code: string;
	dedicated_start_day: string;
	dedicated_template: number;
	def_rate_confirm_temp: number;
	delivered_orders: string;
	delivered_template: number;
	departure_date_at: string;
	descr: string;
	disable_automatic_tracking: string;
	display_eta: string;
	display_ysplit_stops: string;
	distance_method: string;
	distance_profile: string;
	distance_source: string;
	distance_type: string;
	dot_number: string;
	dray_transfer_date: string;
	driver_load: string;
	driver_load_unload: string;
	edi_status: string;
	eir1_no: string;
	eir2_no: string;
	empty_distance_charge_id: string;
	empty_distance_rate: number;
	enable_notifications: string;
	enforce_dep_dates: string;
	entered_date: Date;
	equip_match_detail: string;
	excise_taxable: string;
	excise_taxes: string;
	expected_close: Date;
	extend_rates: string;
	factor_percent: number;
	factor_receivables: string;
	factoring_id: string;
	fak_profile_id: string;
	forwarder: string;
	fourkites_customer_id: string;
	free_days: string;
	freight_items: string;
	fuel_amount: number;
	fuel_base_price: number;
	fuel_credit: string;
	fuel_method: string;
	fuel_percent: number;
	fuel_price_region: string;
	fuel_surcharge_id: string;
	fuel_surchg_enddt: Date;
	fuel_surchg_strtdt: Date;
	fuel_variance: number;
	global_detention: string;
	google_place_id: string;
	gp_exclude: string;
	gp_exported: Date;
	gp_imported: Date;
	grace_period: number;
	handling_req: string;
	has_duplicate: boolean;
	has_duplicate_after_order_entry: boolean;
	high_balance: number;
	high_balance_c: string;
	high_balance_d: Date;
	high_balance_n: number;
	high_balance_r: number;
	ic_alloc_code: string;
	ic_company_id: string;
	ic_order_type: string;
	ic_resp_code: string;
	ic_rev_code: string;
	id: string;
	import_export: string;
	include_by_date: string;
	include_empty_distance: string;
	include_fuel_surcharge: string;
	include_split_point: string;
	integration_type: string;
	invoice_processing_id: string;
	is_active: string;
	is_consignee: string;
	is_distribution_center: string;
	is_drop_yard: string;
	is_geocoded: string;
	is_intercompany: string;
	is_pallets_required: string;
	is_shipper: string;
	is_trailer_pool_required: string;
	jaguar_id: number;
	last_bill_date: Date;
	last_fin_charge_dt: Date;
	last_pay_date: Date;
	last_ship_date: Date;
	latitude: number;
	location_id: string;
	lock_miles: string;
	longitude: number;
	macropoint_requestor_id: string;
	main_phone: string;
	manual_exchange: string;
	mark_plan_id: string;
	max_pay_percent: number;
	misc_bill_template: number;
	monthly_order_goal: number;
	motor_carrier_id: string;
	name: string;
	next_call_date: Date;
	next_rec_call: Date;
	nxt_action_code_id: string;
	nxt_action_date: Date;
	operations_user: string;
	order_count: number;
	order_detail_at: string;
	order_length: string;
	order_start_date: Date;
	order_type: string;
	order_value: string;
	orig_ctrl_party: string;
	orig_ovrd_payee: string;
	orig_revenue_id: string;
	orig_zero_excise_taxes: string;
	orig_zero_frt_chg: string;
	orig_zero_othr_chg: string;
	orig_zero_ovr_pay: string;
	original_bill_to: string;
	original_status: string;
	other_charges: string;
	override_max_city_radius: number;
	p44_profile_id: string;
	paid_loads: number;
	pay_days_date: Date;
	pay_days_orders: number;
	payee_id: string;
	pd0_alert: number;
	pd1_np_auto: string;
	pd1_sp_auto: string;
	pd1_sp_thresh: number;
	pd1_sp_thresh_c: string;
	pd1_sp_thresh_d: Date;
	pd1_sp_thresh_n: number;
	pd1_sp_thresh_r: number;
	pd2_np_auto: string;
	pd2_sp_auto: string;
	pd2_sp_thresh: number;
	pd2_sp_thresh_c: string;
	pd2_sp_thresh_d: Date;
	pd2_sp_thresh_n: number;
	pd2_sp_thresh_r: number;
	pd3_np_auto: string;
	pd3_sp_auto: string;
	pd3_sp_thresh: number;
	pd3_sp_thresh_c: string;
	pd3_sp_thresh_d: Date;
	pd3_sp_thresh_n: number;
	pd3_sp_thresh_r: number;
	pd4_np_auto: string;
	pd4_sp_auto: string;
	pd4_sp_thresh: number;
	pd4_sp_thresh_c: string;
	pd4_sp_thresh_d: Date;
	pd4_sp_thresh_n: number;
	pd4_sp_thresh_r: number;
	pick_up_no: string;
	plc_uid: number;
	post_summary_dtl: string;
	potential: number;
	potential_c: string;
	potential_d: Date;
	potential_n: number;
	potential_r: number;
	prev_code: string;
	primary_agency: string;
	primary_commodity_id: string;
	primary_contact: string;
	primary_sort: string;
	primary_trailer_type: string;
	print_containers: string;
	progress_template: number;
	prospect_type_id: string;
	quebec_number: string;
	quote_days_to_expire: number;
	rate: string;
	rate_override_nmfc_code: string;
	reassign_profile_id: string;
	rec_call_days: number;
	reference_numbers: string;
	remarks: string;
	require_tracking: string;
	required_vendor: string;
	revenue: number;
	revenue_c: string;
	revenue_d: Date;
	revenue_n: number;
	revenue_r: number;
	revenue_start_date: Date;
	routing_guide_profile_id: string;
	sales_manager_id: string;
	sales_status_id: string;
	salesperson_id: string;
	search_city: string;
	search_state_id: string;
	search_zip_code: string;
	secondary_sort: string;
	sell_tariff_id: string;
	service_fail_cons: string;
	service_fail_drop: string;
	service_fail_pick: string;
	service_fail_ship: string;
	service_failures: string;
	service_failures_review: string;
	shipment_ident_type: string;
	showas_location: string;
	sic_code: string;
	smc3_profile_id: string;
	start_date: Date;
	state_id: string;
	stops: string;
	summary_billing: string;
	summary_template: number;
	tar_uid: number;
	target_profit: number;
	tenfour_customer_id: string;
	toll_oc_exempt: string;
	tracking_hours_prior: number;
	trimble_place_id: string;
	type_of: string;
	use_local_mile: string;
	vm_part_update: string;
	waterfall_auto_route_guides: string;
	waterfall_lead_time: number;
	waterfall_notify_email: string;
	waterfall_process: string;
	website_url: string;
	weight: string;
	wf_auto_renbill: string;
	wf_autobill: string;
	wf_bwop: string;
	wf_queue: number;
	y_splits: string;
	zip_code: string;
	zone_id: string;
}

